<template>
    <div class="space-y-5">
        <div>
            <UiInput
                type="text"
                id="name"
                name="name"
                label="Name"
                v-model:inputValue="registerCreds.name"
                :errors="formErrors"
                autofocus
            />
        </div>
        <div>
            <UiInput
                type="email"
                id="email"
                name="email"
                label="Email Address"
                v-model:inputValue="registerCreds.email"
                :errors="formErrors"
            />
        </div>
        <div>
            <UiInput
                type="password"
                id="password"
                name="password"
                label="Password"
                v-model:inputValue="registerCreds.password"
                :errors="formErrors"
                :options="{ toggleHidden: true }"
            />
            <PasswordValidation
                :password="registerCreds.password"
                @isValidPassword="isValidPassword"
            />
        </div>
        <div>
            <UiInput
                type="password"
                id="password-confirm"
                name="password_confirmation"
                label="Password Confirmation"
                v-model:inputValue="registerCreds.password_confirmation"
                :errors="formErrors"
                :options="{ toggleHidden: true }"
            />
        </div>
    </div>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { watch, computed, onMounted } from 'vue';
import { useRegisterStore } from '@/store/register';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import PasswordValidation from '@/components/ui/password-validation/password-validation.vue';

const registerStore = useRegisterStore();
const { registerCreds, formErrors } = storeToRefs(registerStore);

const isValidPassword = (isValid) => {
    //registerCreds.value.password_valid = isValid;
    //console.log(isValid);
};

const doPasswordsMatch = computed(() => {
    if (
        registerCreds.value.password.length > 7 &&
        registerCreds.value.password_confirmation.length > 7
    ) {
        if (
            registerCreds.value.password !==
            registerCreds.value.password_confirmation
        ) {
            return false;
        }
    }

    return true;
});

watch(doPasswordsMatch, (val) => {
    const key = 'password_confirmation';
    const message = 'Passwords do not match';
    if (!val) {
        registerStore.setFormError(key, message);
    } else {
        registerStore.removeFormError(key);
    }
});

onMounted(() => {
    let el = document.getElementById('name');
    if (!el) {
        el = document.getElementById('email');
    }
    if (el && typeof el.focus === 'function') {
        el.focus();
    }
});
</script>
